import { LecturesResType } from './get-lectures-data-operation';
import dateFormat from '../../../utils/date-format';
import dateUtils from '../../../utils/date-format';
import {
  getLectureStatusDisplayText,
  LectureStatus,
} from '../../../api/types/programs/course/lectures/lecture-status.type';
import generateAndDownloadExcelFile from '../../../component/excel/generate-and-download-excel-file';

export const handleExportLecturesToExcel = (
  lecturesData: LecturesResType[],
) => {
  const fileName = 'מפגשים';

  // Create header row
  const headers = [
    'שלוחות',
    'קורס',
    'שם קורס נוסף',
    'תוכניות לימודים',
    'שם תוכנית נוסף',
    'שנת התחלה',
    'מספר סידורי בשנה',
    'אולם',
    'מרצים',
    'שעות',
    'סך תלמידים משובצים',
    'סך תלמידים נוכחים',
    'תאריך',
    'סטטוס מפגש',
  ];

  // Create data rows
  const dataRows = lecturesData.map((lecture) => [
    lecture.branchName || '',
    lecture.courseName || '',
    lecture.additionalCourseName || '',
    lecture.abstractProgramName || '',
    lecture.additionalProgramName || '',
    lecture.programStartYear?.toString() || '',
    lecture.annualSerialProgramNumber?.toString() || '',
    lecture.className || '',
    lecture.lecturers
      .map((lecturer) => `${lecturer.firstName} ${lecturer.lastName}`)
      .join(', ') || '',
    lecture.lecturers[0]
      ? dateFormat.formatTimeRangeBetweenDates(
          lecture.lecturers[0].workingStartTime,
          lecture.lecturers[0].workingEndTime,
        )
      : '',
    lecture.studentNumberInCourse?.toString() || '',
    lecture.lectureStatus === LectureStatus.INIT
      ? 'ההרצאה טרם התחילה'
      : lecture.studentAttendance?.toString() || '',
    lecture.lecturers[0]
      ? dateUtils.displayFormatDate(lecture.lecturers[0].workingStartTime)
      : '',
    getLectureStatusDisplayText(lecture.lectureStatus),
  ]);

  // Combine headers and data
  const excelData = [headers, ...dataRows];

  // Generate and download
  generateAndDownloadExcelFile(excelData, { fileName });
};
